import { ProfessionalEditionPlan, TeamState } from 'frontend/core/src/graphqlTypes/enums';

export { ProfessionalEditionPlan as PLAN_TYPES };
export { TeamState as TEAM_STATE };

export interface ProfessionalCreditsBreakdown {
  additionalUsersCredits: number;
  dataEgressedCredits: number;
  dataProcessedCredits: number;
  dataStoredCredits: number;
  computeCredits: number;
  aiRequestsCredits: number;
}
export interface ProfessionalMeteringInfo {
  userID: string;
  teamID: string;
  teamName: string;
  teamState: TeamState;
  plan: ProfessionalEditionPlan;
  totalCreditsAllocated: number;
  creditsConsumed: number;
  serviceCreditsAllocated: number;
  serviceCreditsConsumed: number;
  userCreditsConsumed: number;
  creditsBreakdown: ProfessionalCreditsBreakdown;
  availableCredits: number;
  from: string;
  to: string;
  creditsCostPerAIRequest: number;
  creditsCostPerCPUHour: number;
  creditsCostPerGBStoredPerMonth: number;
  creditsCostPerGBEgressed: number;
  creditsCostPerUserPerMonth: number;
  totalUsers: number;
  activatedUsers: number;
  includedUsers: number;
  additionalUsers: number;
  proratedUsers: number;
  pricePerCredit: number;
  usageLimit?: {
    alertAmount?: number;
    budgetAmount?: number;
    seats?: number;
  };
  updated_at: string;
  autoUpgraded: boolean;
}

export enum PaymentStatus {
  Paid = 'paid',
  Unpaid = 'unpaid'
}
export interface PaymentStatusResponse {
  paymentStatus: PaymentStatus;
  sessionId: string;
  userId: string;
  teamId: string;
}
export interface CustomerBalance {
  outstandingBalance: number;
  creditBalance: number;
  creditsBreakdown: ProfessionalCreditsBreakdown;
  serviceCreditsConsumed: number;
  userCreditsConsumed: number;
}
